import { render, staticRenderFns } from "./TabsContent.vue?vue&type=template&id=32e62b4a&scoped=true"
import script from "./TabsContent.vue?vue&type=script&lang=js"
export * from "./TabsContent.vue?vue&type=script&lang=js"
import style0 from "./TabsContent.vue?vue&type=style&index=0&id=32e62b4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e62b4a",
  null
  
)

export default component.exports